export default __webpack_public_path__ + "static/media/edit-icon.ef09cf5e.svg";